import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import {
  FiShield,
  FiKey,
  FiInfo,
  FiHelpCircle,
  FiLogOut,
  FiChevronRight,
  FiLock
} from 'react-icons/fi';
import Header from './Header';
import '../styles/SettingsPage.css';
import { toast } from 'react-toastify';

const SettingsPage = () => {
  const navigate = useNavigate();
  const { disconnect } = useWallet();

  const handleLogout = () => {
    disconnect();
    navigate('/welcome');
  };

  const clearAppCache = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      if (window.caches) caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
      toast.success('App cache cleared!');
      window.location.reload();
    } catch (e) {
      toast.error('Failed to clear cache');
    }
  };

  const settingsGroups = [
    {
      title: "Security & Privacy",
      items: [
        {
          icon: FiShield,
          title: 'Security',
          description: 'Privacy and security settings',
          onClick: () => navigate('/settings/security')
        },
        {
          icon: FiKey,
          title: 'Recovery Phrase',
          description: 'View your secret recovery phrase',
          onClick: () => navigate('/settings/recovery-phrase')
        },
        {
          icon: FiLock,
          title: 'Change PIN',
          description: 'Update your wallet PIN',
          onClick: () => navigate('/settings/change-pin')
        }
      ]
    },

    {
      title: "Support",
      items: [
        {
          icon: FiHelpCircle,
          title: 'Help Center',
          description: 'Get support and send feedback',
          onClick: () => navigate('/settings/help')
        },
        {
          icon: FiInfo,
          title: 'About',
          description: 'App version and information',
          onClick: () => navigate('/settings/about')
        }
      ]
    }
  ];

  return (
    <div className="settings-page">
      <Header title="Settings" className="sticky-header" />

      <div className="settings-content">
        <motion.div
          className="settings-card"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {settingsGroups.map((group, groupIndex) => (
            <div key={group.title} className="settings-group">
              <h2 className="group-title">{group.title}</h2>
              <div className="settings-list">
                {group.items.map((item, index) => {
                  const Icon = item.icon;
                  return (
                    <motion.button
                      key={item.title}
                      className="settings-item"
                      onClick={item.onClick}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: (groupIndex * 0.1) + (index * 0.05) }}
                      whileHover={{ scale: 1.02, x: 4 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <div className="item-content">
                        <div className="item-icon">
                          <Icon />
                        </div>
                        <div className="item-text">
                          <span className="item-title">{item.title}</span>
                          <span className="item-description">{item.description}</span>
                        </div>
                      </div>
                      <FiChevronRight className="chevron-icon" />
                    </motion.button>
                  );
                })}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.button
          className="logout-button"
          onClick={handleLogout}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FiLogOut />
          <span>Log Out</span>
        </motion.button>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <button className="btn btn-danger" onClick={clearAppCache}>
            <i className="fas fa-trash me-2"></i>Clear App Cache
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage; 